
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 21l-6-2.1-4.65 1.8a.902.902 0 01-.925-.113A.986.986 0 013 19.75v-14c0-.217.063-.408.188-.575.125-.167.295-.292.512-.375L9 3l6 2.1 4.65-1.8a.904.904 0 01.925.112.989.989 0 01.425.838v14a.931.931 0 01-.188.575 1.126 1.126 0 01-.512.375L15 21zm-1-2.45V6.85l-4-1.4v11.7l4 1.4z"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}})])])
          )
        }
      }
    